import { render, staticRenderFns } from "./ChangeActiveContactDialog.vue?vue&type=template&id=55754d90"
import script from "./ChangeActiveContactDialog.vue?vue&type=script&lang=ts"
export * from "./ChangeActiveContactDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports